import * as React from 'react';
import s from './bugFixes.scss';
import BugFixArticle from '../partials/BugFixArticle';
type BugFixesProps = {
  articles: any[]
};
class BugFixes extends React.Component<BugFixesProps, {}> {
  render() {
    const {articles} = this.props;
    return (
      <ul className={s.layout}>
        {articles.map(article => (
          <BugFixArticle article={article} key={article.id} />
        ))}
      </ul>
    );
  }
}
export default BugFixes;
